import React, { useState } from 'react';
import { Brain as BrainIcon, MessageCircle, ScrollText } from 'lucide-react';
import BrainPanel from './BrainPanel';
import CortexPanel from './CortexPanel';
import AuthorChatPanel from './AuthorChatPanel';
import useAdminPageMeta from '../../hooks/useAdminPageMeta';

const TABS = [
  { id: 'brain', label: 'The Brain', icon: BrainIcon, desc: 'Persona, rules, knowledge' },
  { id: 'cortex', label: 'The Cerebral Cortex', icon: ScrollText, desc: 'Book versions · AI summaries' },
  { id: 'chat', label: 'Chat with EE', icon: MessageCircle, desc: 'Unfiltered author chat' },
];

const TAB_TITLES = {
  brain: 'EE Training · The Brain',
  cortex: 'EE Training · The Cerebral Cortex',
  chat: 'EE Training · Chat with EE',
};

export default function EETrainingPage() {
  const [tab, setTab] = useState('brain');
  useAdminPageMeta(TAB_TITLES[tab] || 'EE Training');
  return (
    <div className="p-4 sm:p-6 md:p-10">
      <div className="mb-6 md:mb-8">
        <h1 className="hero-title text-3xl md:text-4xl text-white">EE Training</h1>
        <p className="text-ee-text2">Shape EE’s mind: persona, rules, knowledge, and book content.</p>
      </div>
      <div className="flex flex-wrap gap-2 mb-6">
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = tab === t.id;
          return (
            <button data-testid={`ee-tab-${t.id}`} key={t.id} onClick={() => setTab(t.id)} className={`group flex items-start gap-3 px-3 sm:px-4 py-3 rounded-lg border transition-all w-full sm:flex-1 sm:min-w-[200px] text-left ${active ? 'border-gold bg-gold/10' : 'border-ee-border bg-ee-card hover:border-gold/30'}`}>
              <Icon size={18} className={`mt-0.5 flex-shrink-0 ${active ? 'text-gold' : 'text-ee-muted'}`} />
              <div className="min-w-0">
                <div className={`text-sm font-medium ${active ? 'text-gold' : 'text-white'}`}>{t.label}</div>
                <div className="text-xs text-ee-muted">{t.desc}</div>
              </div>
            </button>
          );
        })}
      </div>
      {tab === 'brain' && <BrainPanel />}
      {tab === 'cortex' && <CortexPanel />}
      {tab === 'chat' && <AuthorChatPanel />}
    </div>
  );
}
